<mat-dialog-actions>
  <h2 class="title" >Настройки графа</h2>
  <mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<form [formGroup]="graphSettings" class="settings">
<div class="settings-base">
  <mat-form-field  class="form-field-cs" floatLabel="always" hideRequiredMarker="true">
<!--     <mat-icon matPrefix svgIcon="user-shared-fill" class="form-field-icon"></mat-icon> -->
    <mat-label>Библиотека</mat-label>
    <mat-select [formControl]="package" disableRipple panelClass="payment-select-panel" placeholder="Выбрать">
        <mat-option [value]="'dagre'">Dagre</mat-option>
        <mat-option [value]="'ELK'">ELK</mat-option>
    </mat-select>
    @if (package.hasError('required')) {
      <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field  class="form-field-cs" floatLabel="always" hideRequiredMarker="true">
<!--     <mat-icon matPrefix svgIcon="user-shared-fill" class="form-field-icon"></mat-icon> -->
    <mat-label>Алгоритм узлов</mat-label>
    <mat-select [formControl]="algorithm" disableRipple panelClass="payment-select-panel" placeholder="Выбрать">
      @for (algo of algorithmsList;  track algo) {
        <mat-option *ngIf="algo?.package===package?.value" [value]="algo.algorithm">{{algo.algorithm}}</mat-option>
      }
    </mat-select>
    @if (algorithm.hasError('required')) {
      <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field  class="form-field-cs" floatLabel="always" hideRequiredMarker="true">
<!--     <mat-icon matPrefix svgIcon="user-shared-fill" class="form-field-icon"></mat-icon> -->
    <mat-label>Расчет связей</mat-label>
    <mat-select [formControl]="algorithmEdges" disableRipple panelClass="payment-select-panel" placeholder="Выбрать">
      <mat-option *ngIf="package.value==='dagre'" [value]="'dagre'">Dagre(по умолчанию)</mat-option>
      <mat-option [value]="'local'">Локальный (4 точки)</mat-option>
      <mat-option *ngIf="package.value==='ELK'" [value]="'ELK'">ELK (тестирование)</mat-option>

    </mat-select>
    @if (algorithmEdges.hasError('required')) {
      <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
    }
  </mat-form-field>
  
</div>

<div class="settings-paddings">
  <mat-form-field  class="form-field-cs" floatLabel="always" hideRequiredMarker="true">
   <!--  <mat-icon matPrefix svgIcon="user-received-2-fill" class="form-field-icon" ></mat-icon> -->
    <mat-label>Тип связей</mat-label>
    <mat-select [formControl]="edgeType" disableRipple  panelClass="payment-select-panel" placeholder="Выбрать">
        <mat-option *ngIf="algorithmEdges.value==='dagre'" [value]="'dagre'">Пакет Dagre</mat-option>
        <mat-option *ngIf="algorithmEdges.value==='ELK'" [value]="'dagre'">Пакет ELK</mat-option>
        <mat-option *ngIf="algorithmEdges.value==='local'" [value]="'bezier'">Кривые Безье</mat-option>
        <mat-option *ngIf="algorithmEdges.value==='local'" [value]="'smoothstep'">Ломанные сглаженные</mat-option>
        <mat-option *ngIf="algorithmEdges.value==='local'" [value]="'straight'">Прямые линии</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field  class="form-field-cs" floatLabel="always" hideRequiredMarker="true">
   <!--  <mat-icon matPrefix svgIcon="user-received-2-fill" class="form-field-icon" ></mat-icon> -->
    <mat-label>Тип указателя</mat-label>
    <mat-select [formControl]="pointerType" disableRipple  panelClass="payment-select-panel" placeholder="Выбрать">
        <mat-option [value]="'arrow'">Указатель</mat-option>
        <mat-option [value]="'circle'">Круг</mat-option>
        <mat-option [value]="'rect'">Прямоугольник</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="settings-paddings">
  <mat-form-field  class="form-field-cs" floatLabel="always" hideRequiredMarker="true">
   <!--  <mat-icon matPrefix svgIcon="user-received-2-fill" class="form-field-icon" ></mat-icon> -->
    <mat-label>Направление</mat-label>
    <mat-select [formControl]="orientation" disableRipple  panelClass="payment-select-panel" placeholder="Выбрать">
        <mat-option [value]="'LR'">Слева направо</mat-option>
        <mat-option [value]="'TB'">Сверху вниз</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field  class="form-field-cs" floatLabel="always">
    <!--         <mat-icon matPrefix svgIcon="wallet-2-fill" class="form-field-icon"></mat-icon> -->
    <mat-label>Шаг по вертикали</mat-label>
    <input matInput formControlName="rankPadding" autocomplete="disabled" placeholder="0">
      <mat-error *ngIf="rankPadding?.errors?.['pattern']">{{ 'VALIDATION.FORMAT' | translate}} </mat-error>
      <mat-error *ngIf="rankPadding?.errors?.['required']">{{ 'VALIDATION.REQUIRED' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field class="form-field-cs" floatLabel="always">
      <!--         <mat-icon matPrefix svgIcon="wallet-2-fill" class="form-field-icon"></mat-icon> -->
      <mat-label>Шаг по горизонтали</mat-label>
      <input matInput formControlName="nodePadding" autocomplete="disabled" placeholder="0">
      <mat-error *ngIf="nodePadding?.errors?.['pattern']">{{ 'VALIDATION.FORMAT' | translate}} </mat-error>
      <mat-error *ngIf="nodePadding?.errors?.['required']">{{ 'VALIDATION.REQUIRED' | translate}}</mat-error>
  </mat-form-field>
</div>

  <div class="settings-button-block">
    <button 
      [disabled]="graphSettings.invalid"
      (click)="drawGraphByNewSettings()"  data-action="drawGraphByNewSettings"
      class="button-icon size-xxl primary-button" type="submit" >
      <mat-icon svgIcon="checkbox-fill"></mat-icon>
      {{('CONFIRM.BUTTONS.CONFIRM'|translate) }}
    </button>
    <button mat-dialog-close class="button-icon size-xxl secondary-button">
      <mat-icon svgIcon="close-line"></mat-icon>
      {{ 'CONFIRM.BUTTONS.CANCEL'|translate }}
    </button>
  </div>
  </form>
